import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'

import { Lazyload } from 'vant'
import directive from "@/utils/directive"
createApp(App).use(store).use(Lazyload).use(directive).mount('#app')

import VConsole from 'vconsole'
if (location.host == 'test.foshanplus.com') {
    new VConsole()
}